import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import ReviewCertificate from "../ReviewCertificate";
import { trackEvent } from "../../utils/tracking";
import QuickContact from "./QuickContact";

const Footer = () => {
  const [nlStatus, setNlStatus] = useState({ type: "", message: "" });
  const [nlSubmitting, setNlSubmitting] = useState(false);
  const nlForm = useRef();

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    setNlSubmitting(true);
    setNlStatus({ type: "", message: "" });

    const emailValue = nlForm.current.querySelector('input[name="email"]').value;

    emailjs
      .send("service_f4grfuj", "template_bjg4ob4", {
        name: "Newsletter Subscriber",
        email: emailValue,
        reply_to: emailValue,
        device: "N/A",
        subject: "Newsletter Signup",
        message: "New newsletter signup from website footer. Email: " + emailValue,
      }, {
        publicKey: "LyFrQSP0J8xcnoKSH",
      })
      .then(
        () => {
          setNlStatus({
            type: "success",
            message: "You're subscribed! Watch your inbox for deals & tips.",
          });
          nlForm.current.reset();
          setNlSubmitting(false);
        },
        () => {
          setNlStatus({
            type: "error",
            message: "Something went wrong. Please try again.",
          });
          setNlSubmitting(false);
        }
      );
  };

  return (
    <>
      {/* start footer */}
      <footer
        className="footer section bg-cover overlay-dark pt-60"
        style={{ backgroundImage: "url(assets/images/bg-footer.jpg)" }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-3 col-md-6 mt-40">
              <img
                className="mb-25"
                src={process.env.PUBLIC_URL + "/assets/images/logoFooter.png"}
                alt="Cell Station Logo"
                loading="lazy"
                style={{ maxWidth: "180px" }}
              />
              <p className="text-gray">
                Your trusted local phone and computer repair shop since 2006.
                Fast, reliable service with quality parts and warranty included.
              </p>

              {/* Trust Badges */}
              <div
                className="mt-20"
                style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.1)",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "0.75rem",
                    color: "#dddddd",
                  }}
                >
                  <i className="fas fa-shield-alt text-primary mr-2" />
                  Warranty
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.1)",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "0.75rem",
                    color: "#dddddd",
                  }}
                >
                  <i className="fas fa-clock text-primary mr-2" />
                  Same Day
                </span>
              </div>
              <ul className="social-links list-unstyled mt-25">
                <li>
                  <a
                    href="https://www.facebook.com/icellstation/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="initiate-scripts"
                    aria-label="Facebook"
                  >
                    <span className="fab fa-facebook-f" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@icellstation?lang=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="initiate-scripts"
                    aria-label="TikTok"
                  >
                    <span className="fab fa-tiktok" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC_ju-JULprEqMmO3Wlj7DyA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="initiate-scripts"
                    aria-label="YouTube"
                  >
                    <span className="fab fa-youtube" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-xl-2 col-md-6 mt-40">
              <h4 className="font-w-600 text-white mb-10">Quick Links</h4>
              <ul className="footer-links list-unstyled text-uppercase">
                <li>
                  <Link to={"/services"} className="initiate-scripts">
                    SERVICES
                  </Link>
                </li>
                <li>
                  <Link to={"/blog"} className="initiate-scripts">
                    BLOG
                  </Link>
                </li>
                <li>
                  <Link to={"/about-us"} className="initiate-scripts">
                    ABOUT
                  </Link>
                </li>
                <li>
                  <Link to={"/contact-us"} className="initiate-scripts">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-2 col-md-6 mt-40">
              <h4 className="font-w-600 text-white mb-10">Areas We Serve</h4>
              <ul className="footer-links list-unstyled">
                <li>
                  <Link to="/areas/philadelphia" className="initiate-scripts">
                    Philadelphia, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/horsham" className="initiate-scripts">
                    Horsham, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/abington" className="initiate-scripts">
                    Abington, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/hatboro" className="initiate-scripts">
                    Hatboro, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/warminster" className="initiate-scripts">
                    Warminster, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/glenside" className="initiate-scripts">
                    Glenside, PA
                  </Link>
                </li>
                <li>
                  <Link to="/areas/jenkintown" className="initiate-scripts">
                    Jenkintown, PA
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-2 col-md-6 mt-40">
              <h4 className="font-w-600 text-white mb-10">POLICIES</h4>
              <ul className="footer-links list-unstyled text-uppercase">
                <li>
                  <Link
                    to={"/terms-conditions"}
                    className="initiate-scripts"
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/privacy-policy"}
                    className="initiate-scripts"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/return-refund-policy"}
                    className="initiate-scripts"
                  >
                    Returns & Refunds
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/warranty-policy"}
                    className="initiate-scripts"
                  >
                    Warranty Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-md-6 mt-40">
              <h4 className="font-w-600 text-white mb-10">Get in Touch</h4>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-phone-alt mr-2" />
                <a
                  href="tel:+12159393933"
                  style={{ color: "#dddddd" }}
                  onClick={() => trackEvent.phoneCall({ source: "footer" })}
                >
                  (215) 939-3933
                </a>
              </div>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-envelope mr-2" />
                <a
                  href="mailto:icellstation1@gmail.com"
                  style={{ color: "#dddddd" }}
                >
                  icellstation1@gmail.com
                </a>
              </div>
              <div className="text-gray mt-20">
                <span className="icon text-primary fas fa-map-marker-alt mr-2" />
                <Link to="/store-location" style={{ color: "#dddddd" }}>
                  2500 W Moreland Rd, Space #1077
                  <br />
                  <span style={{ marginLeft: "22px" }}>
                    Willow Grove, PA 19090
                  </span>
                </Link>
              </div>

              {/* Business Hours */}
              <h4 className="font-w-600 text-white mb-10 mt-30">
                Store Hours
              </h4>
              <div style={{ color: "#dddddd", fontSize: "0.9rem" }}>
                <div
                  className="d-flex justify-content-between"
                  style={{ maxWidth: "200px" }}
                >
                  <span>Mon - Thu:</span>
                  <span>10AM - 8PM</span>
                </div>
                <div
                  className="d-flex justify-content-between"
                  style={{ maxWidth: "200px" }}
                >
                  <span>Fri - Sat:</span>
                  <span>10AM - 9PM</span>
                </div>
                <div
                  className="d-flex justify-content-between"
                  style={{ maxWidth: "200px" }}
                >
                  <span>Sunday:</span>
                  <span>10AM - 8PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="row mt-40">
            <div className="col-12">
              <div
                style={{
                  borderTop: "1px solid rgba(255,255,255,0.15)",
                  paddingTop: "30px",
                  paddingBottom: "10px",
                }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-5 mb-20 mb-lg-0">
                    <h4 className="font-w-600 text-white" style={{ marginBottom: "5px" }}>
                      <i className="fas fa-envelope-open-text mr-2" style={{ color: "#ffaa19" }} />
                      Get Exclusive Deals & Repair Tips
                    </h4>
                    <p className="text-gray" style={{ margin: 0, fontSize: "0.9rem" }}>
                      Subscribe for special offers, tech tips, and seasonal promotions.
                    </p>
                  </div>
                  <div className="col-lg-7">
                    <form
                      ref={nlForm}
                      onSubmit={handleNewsletterSubmit}
                      style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}
                    >
                      {/* Hidden fields for EmailJS template */}
                      <input type="hidden" name="name" value="Newsletter Subscriber" />
                      <input type="hidden" name="subject" value="Newsletter Signup" />
                      <input type="hidden" name="message" value="New newsletter signup from website footer." />
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="Enter your email address"
                        style={{
                          flex: "1",
                          minWidth: "220px",
                          padding: "12px 18px",
                          borderRadius: "5px",
                          border: "none",
                          fontSize: "0.95rem",
                          outline: "none",
                        }}
                      />
                      <button
                        type="submit"
                        disabled={nlSubmitting}
                        className="btn btn-primary"
                        style={{ padding: "12px 25px", whiteSpace: "nowrap" }}
                      >
                        {nlSubmitting ? (
                          <><i className="fas fa-spinner fa-spin mr-2" />Subscribing...</>
                        ) : (
                          <><i className="fas fa-paper-plane mr-2" />Subscribe</>
                        )}
                      </button>
                    </form>
                    {nlStatus.message && (
                      <div
                        style={{
                          marginTop: "10px",
                          padding: "8px 14px",
                          borderRadius: "5px",
                          fontSize: "0.85rem",
                          background: nlStatus.type === "success"
                            ? "rgba(40, 167, 69, 0.2)"
                            : "rgba(220, 53, 69, 0.2)",
                          color: nlStatus.type === "success" ? "#8fd19e" : "#f5a0a7",
                        }}
                      >
                        <i
                          className={`fas ${nlStatus.type === "success" ? "fa-check-circle" : "fa-exclamation-circle"} mr-2`}
                        />
                        {nlStatus.message}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Copyright <span style={{ color: "#ffaa19" }}>&copy;</span>2025
                by <span style={{ color: "#ffaa19" }}>Cell Station.</span> All
                rights reserved.
              </p>
              <ReviewCertificate />
            </div>
          </div>
        </div>
      </div>
      {/* end footer */}

      {/* scroll to top button removed */}

      {/* Mobile Sticky CTA Bar */}
      <div className="mobile-sticky-cta">
        <div className="cta-buttons">
          <a
            href="tel:+12159393933"
            className="btn btn-call"
            onClick={() => trackEvent.phoneCall({ source: "mobile_sticky" })}
          >
            <i className="fas fa-phone-alt" />
            Call Now
          </a>
          <Link to="/contact-us" className="btn btn-quote">
            <i className="fas fa-comment-dots" />
            Get Quote
          </Link>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/12159393933?text=Hi%20Cell%20Station!%20I%20need%20help%20with%20a%20repair."
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        onClick={() => trackEvent.whatsappClick({ source: "float_button" })}
      >
        <i className="fab fa-whatsapp" />
        <span className="tooltip-text">Chat with us!</span>
      </a>

      {/* Site-wide quick-contact launcher (bottom-left) */}
      <QuickContact />
    </>
  );
};

export default Footer;
